module.exports = {
  TheNotYourCustomerSelect: 'The entrusted unit is not your customer, please re-select!',
  YourAuthorityIsInsufficient: 'Your authority is insufficient.',
  SailingSchedule2: 'Sailing schedule 2:',
  Voyage: 'Voyage:',
  OverweightDescription: 'Overweight description:',
  LowestPrice: 'Lowest price',
  SailingSchedule: 'Sailing schedule:',
  FullContainerFreightSharingDetails: 'Full container freight sharing details',
  FullContainerFCLFreight: 'Full container (FCL) freight',
  LessContainerLoadLCLFreight: 'Less container load (LCL) freight',
  AirCargoAIRFreight: 'Air cargo (AIR) freight',
  All: 'All',
  Code: 'Code',
  ChineseName: 'Chinese name',
  EnglishName: 'English name',
  Country: 'Country',
  Region: 'Region',
  AirFreightSurchargeDetails: 'Air freight surcharge details',
  Empty: 'Empty',
  LCLDestinationPortChargesDetails: 'LCL destination port charges details',
  AirCargoRateDetails: 'Air cargo rate details',
  SecondTransit: 'Second transit',
  SecondLegAircraftType: 'Second leg aircraft type',
  SecondLegFlightSchedule: 'Second leg flight schedule',
  SecondScheduleCannotBeEmpty: 'Second leg flight schedule cannot be empty.',
  ProgramSettings: 'Program settings',
  FullContainerFreightDetails: 'Full container freight details',
  EuropeAndAmericaLinesDedicated: 'Europe and America lines dedicated',
  EmailCannotBeEmpty: 'Email cannot be empty',
  EmailFormatError: 'Email format error',
  DestinationAreaError: 'Destination area error!',
  ContinueImporting: ', continue importing?',
  FullContainerAddonFreightDetails: 'Full container Addon freight details',
  FullContainerAdditionalInformationDetails: 'Full container additional information details',
  LCLFreightDetails: 'LCL freight details',
  CostPrice: 'Cost price',
  PeerPrice: 'Peer price',
  DirectCustomerPrice: 'Direct customer price',
  MarketPrice: 'Market price',
  LCLAddonFreightDetails: 'LCL Addon freight details',
  YourPermissionIsNotEnough: 'Your permission is not enough.',
  SailingTime: 'Sailing time:',
  FCL: 'FCL',
  LCL: 'LCL',
  FreightNumber: 'Freight number:',
  CabinStatus: 'Cabin status:',
  OurDumpingOfContainersOK: 'Our company cannot guarantee no dumping of containers under pre-allocation OK.',
  NoteAdditionalChargesWithBackground: 'Note: ALL IN price includes additional charges with a gray background.',
  Booking: 'Booking',
  ThisFareHasExpired: 'This fare has expired!',
  NoFreightThatMeetsParty: 'No sailing date can be found within the validity period of the freight that meets the sailing schedule requirements. Please confirm with the booking party!',
  Subscribe: 'Subscribe',
  SetEmailToReceiveInformation: 'Set up the email to receive subscription information',
  TheEmailCannotBeEmpty: 'The email cannot be empty',
  SetCompanyToReceiveInformation: 'Set up the (sub) company to receive your subscription information',
  SetYouWantToTo: 'Set up the partner you want to subscribe to',
  AdvancedSettings: 'Advanced settings',
  SubscriptionType: 'Subscription type',
  PlaceOfDeparture: 'Place of departure',
  DischargePort: 'Discharge port',
  Airline: 'Airline',
  ShippingCompany: 'Shipping company',
  Confirm: 'Confirm',
  Reset: 'Reset',
  Refresh: 'Refresh',
  Cancel: 'Cancel',
  PleaseYouWillReceiveUpdated: 'Please subscribe to the information you are interested in, and you will receive a reminder email when the freight is updated.',
  Add: 'Add',
  Edit: 'Edit',
  Delete: 'Delete',
  GoBack: 'Go back',
  Save: 'Save',
  SubCompany: 'Sub-Company',
  DeparturePort: 'Departure Port',
  DepartureCountry: 'Departure Country',
  DepartureArea: 'Departure Area',
  DestinationPort: 'Destination Port',
  DestinationCountryRegion: 'Destination Country (Region)',
  DestinationArea: 'Destination Area',
  FCLWeightLimitInformationDetails: 'FCL Weight Limit Information Details',
  PleaseTheEntrustedContainerVolume: 'Please enter the entrusted container volume!',
  TheBelongToYourSelect: 'The entrusting unit does not belong to your customer, please re-select!',
  ExternalUser: 'External User',
  FCLSailingScheduleManagement: 'FCL Sailing Schedule Management',
  ConfigSurchargeFcl: 'Config Surcharge Fcl',
  FCLAdditionalFeeMaintenance: 'FCL Additional Fee Maintenance'
}
